import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router';
import {useNavigate} from 'react-router-dom';
import { LeftOutlined} from '@ant-design/icons';
import {useMutation} from '@apollo/client';
import {Button, Input} from 'antd';
import _ from 'lodash';
import {observer} from 'mobx-react-lite';

import {Header} from '../../components/Header/Header';
import Layout from '../../components/Layout/Layout';
import labels from '../../config/labels.json';
import {ILabel} from '../../config/lebels-type';
import {createStory, createStoryVariables} from '../../shared/graphql/__generated__/createStory';
import {MUTATION_CREATE_STORY} from '../../shared/graphql/story';

import cls from './Story.module.scss'

export const Write = observer(() => {

    const navigate = useNavigate()
    const {state} = useLocation();
    const {t} = useTranslation()

    const [description, setDescription] = useState<string>('')
    const [create] = useMutation<createStory, createStoryVariables>(MUTATION_CREATE_STORY)
    
    const label = _.filter(labels, (label: ILabel) => label.identifier === state.identifier)[0]?.label;

    const onSave = async () => {
        await create({
            variables: {
                data: {
                    identifier: state.identifier,
                    description: description,
                }
            },
            onCompleted: () => {
                navigate(-1)
            }
        })
    }

    return (
        <Layout header={<Header title={t(label)}
                                left={<Button onClick={() => navigate(-1)} size={'small'} shape={'circle'} type={'link'}
                                              icon={<LeftOutlined/>}/>}/>}>
            <div className={cls.write}>

                <Input.TextArea autoFocus className={cls.area} onChange={(e) => setDescription(e.target.value)} value={description} placeholder={t('Description')!}/>
                <Button type={'primary'} onClick={onSave}>{t('Save')}</Button>

            </div>
        </Layout>

    )
})